
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b2b",
      function () {
        return require("private-next-pages/b2b/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b2b"])
      });
    }
  